import { Language } from '../constants';
export const ARROW_SPACING = 20;
export const TooltipPlacement = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT: 'right',
  BOTTOM_START: 'bottom-start',
  BOTTOM: 'bottom',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left'
};
export const TooltipVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  ATTENTION: 'attention',
  MONO_100: 'mono_100',
  MONO_900: 'mono_900',
  MONO_200: 'mono_200'
};
export const TooltipTextAlign = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
export const DEFAULT_TOOLTIP_VARIANT = TooltipVariant.MONO_100;
export const ARROW_HEIGHT = 10;
export const ARROW_WIDTH = 20;
export const TOOLTIP_TRANSLATIONS_KEYS = {
  accessibleCloseIconButtonLabel: 'component.Tooltip.accessibleCloseIconButtonLabel'
};
export const TOOLTIP_TRANSLATIONS = {
  [Language.CS]: {
    [TOOLTIP_TRANSLATIONS_KEYS.accessibleCloseIconButtonLabel]: 'Zavřít'
  },
  [Language.EN]: {
    [TOOLTIP_TRANSLATIONS_KEYS.accessibleCloseIconButtonLabel]: 'Close'
  },
  [Language.PL]: {
    [TOOLTIP_TRANSLATIONS_KEYS.accessibleCloseIconButtonLabel]: 'Zamknij'
  },
  [Language.SK]: {
    [TOOLTIP_TRANSLATIONS_KEYS.accessibleCloseIconButtonLabel]: 'Zavrieť'
  }
};